import { useMutation, useQueryClient } from '@tanstack/react-query';
import { showNotification } from '@mantine/notifications';
import { QUERY_KEYS } from '@/constants/queryKeys';
import { churchesService } from '@/services/churches.service';
import { mapEvaSyncRunViewToListing } from '@/shared/utils';
import type { EvaSyncRunCreateRequest, EvaSyncRunListing } from '@/types/evaSync';

export const useCreateEvaSyncRun = (churchId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: EvaSyncRunCreateRequest) => churchesService.createEvaSyncRun(churchId, payload),
    onSuccess: (createdRun) => {
      const newRun = mapEvaSyncRunViewToListing(createdRun);

      queryClient.setQueryData<EvaSyncRunListing[]>([QUERY_KEYS.EVA_SYNC_RUNS, churchId], (existingRuns = []) => {
        const runsWithoutDuplicate = existingRuns.filter((run) => run.id !== newRun.id);
        return [newRun, ...runsWithoutDuplicate];
      });

      void queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.EVA_SYNC_RUNS, churchId] });

      showNotification({ title: 'Success', message: 'Eva sync started successfully', color: 'green' });
    },
  });
};
